import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SAAValidationWarningStore, SAAValidationWarningByForm } from "../types/stores/saaValidationWarning";

const initialState: SAAValidationWarningStore = {
    byForm: {},
    isLoading: false,
};

const slice = createSlice({
    name: "validationWarning",
    initialState,
    reducers: {
        validationWarningIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateValidationWarning: (
            state,
            action: PayloadAction<{ formId: string; messages: SAAValidationWarningByForm }>
        ) => {
            state.byForm[action.payload.formId] = action.payload.messages;
        },
    },
});

export default slice.reducer;

export const { validationWarningIsLoading, updateValidationWarning } = slice.actions;
